<template>
  <div class="animated fadeIn form-abm">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <b-form>
            <b-form-group
              label="Razón Social"
              label-for="razonSocial"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="razonSocial"
                v-model.trim="$v.razonSocial.$model" 
                :state="razonSocialValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="razonSocialFeedback">
                {{ razonSocialInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
            <b-form-group
              label="Nombre Comercial"
              label-for="nombreComercial"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombreComercial"
                v-model.trim="$v.nombreComercial.$model" 
                :state="nombreComercialValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreComercialFeedback">
                {{ nombreComercialInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-condicion-fiscal
              label="Cond.Fiscal"
              :nombre="condicionFiscalNombre"
              :labelCols="labelCols"
              :valido="condicionFiscalValida"
              :lista="condicionesFiscalesList"
              :msjInvalido="condicionFiscalInvalidaMsj"
              @validate="validate"
              @updated="condicionFiscalActualizada">
            </app-condicion-fiscal>  

            <app-documento-tipo
              label="Tipo Identificación"
              :nombre="documentoTipoNombre"
              :lista="documentosTiposList"
              :valido="documentoTipoValido"
              :msjInvalido="documentoTipoInvalidoMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="documentoTipoActualizado">
            </app-documento-tipo>  

            <b-form-group
              label="Cód. Identificación"
              label-for="documentoNumero"
              :label-cols="labelCols"
              description="Código de identificación tributaria (CUIT, RUT, CIF, TIN\EIN, etc)"
              horizontal>
              <b-form-input 
                id="documentoNumero"
                v-model.trim= "$v.documentoNumero.$model" 
                :state="documentoNumeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="documentoNumeroFeedback">
                {{ documentoNumeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <!-- <b-form-group
              label="CUIT"
              label-for="cuit"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cuit"
                v-model.trim="$v.cuit.$model" 
                :state="cuitValido"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cuitFeedback">
                {{ cuitInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group> -->

            <b-form-group
              label="Teléfono"
              label-for="telefono"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="telefono"
                v-model.trim="$v.telefono.$model" 
                :state="telefonoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="telefonoFeedback">
                {{ telefonoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Celular"
              label-for="celular"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="celular"
                v-model.trim="$v.celular.$model" 
                :state="celularValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="celularFeedback">
                {{ celularInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Email"
              label-for="email"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="email"
                v-model.trim="$v.email.$model" 
                :state="emailValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="emailFeedback">
                {{ emailInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Email"
              label-for="email2"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="email2"
                v-model.trim="$v.email2.$model" 
                :state="email2Valido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="email2Feedback">
                {{ email2InvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import CondicionFiscal from '../shared/abmSelect.vue';
import DocumentoTipo from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, requiredIf, numeric, maxLength, email } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'proveedor/getField',
  mutationType: 'proveedor/updateField',
});

const CBU = ((value, vm) => {
  /* Validamos CBU solo si el banco es argentino */
  if (value == '' || vm.bancoPaisId != 1) {
    return true;
  } else {
    if (!isNaN(parseInt(value))) {
      if ((value.length == 1 && parseInt(value) == 0) || value.length == 22) {
        return true;
      }
    }
  }

  return false;
})

const DocumentoValido = ((value, vm) => {
  if (value == '') {
    return true;
  } else {

    let isValid = true;
    switch (vm.documentoTipoId) {
      case 2:
        /* Cuit (11 digitos numéricos) */
        if (isNaN(parseInt(value))) {
          isValid = false;
        } else {
          let length = Math.log(value) * Math.LOG10E + 1 | 0;  
          if (length != 0 & length != 11) {
            isValid = false;
          }
        }
        break;

      // case 4:
      //   /* TIN / EIN  (9 digitos numéricos) */
      //   if (isNaN(parseInt(value))) {
      //     isValid = false;
      //   } else {
      //     let length = Math.log(value) * Math.LOG10E + 1 | 0;  
      //     if (length != 0 & length != 9) {
      //       isValid = false;
      //     }
      //   }
      //   break;
    }
    return isValid;
  }
})

export default {
  name: 'ABM',
  components: {
    appCondicionFiscal: CondicionFiscal,
    appDocumentoTipo: DocumentoTipo,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      nombreComercialValido: null,
      nombreComercialInvalidoMsj: '',
      razonSocialValida: null,
      razonSocialInvalidaMsj: '',
      condicionFiscalValida: null,
      condicionFiscalInvalidaMsj: '',
      documentoTipoValido: null,
      documentoTipoInvalidoMsj: '',
      documentoNumeroValido: null,
      documentoNumeroInvalidoMsj: '',
      // cuitValido: null,
      // cuitInvalidoMsj: '',
      telefonoValido: null,
      telefonoInvalidoMsj: '',
      celularValido: null,
      celularInvalidoMsj: '',
      emailValido: null,
      emailInvalidoMsj: '',
      email2Valido: null,
      email2InvalidoMsj: '',

      condicionesFiscales: [],
      condicionesFiscalesList: [],
      documentosTipos: [],
      documentosTiposList: [],

      labelCols: 3
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombreComercial',
      'razonSocial',
      'condicionFiscal',
      'condicionFiscalNombre',
      'documentoTipoId',
      'documentoTipo',
      'documentoTipoNombre',
      'documentoNumero',
      // 'cuit',
      'telefono',
      'celular',
      'email',
      'email2',

      'bancoPaisId'
    ])
  },  
  created() {
    let params= {
      proveedorId: 0
    }

    this.showSpinner();
    this.$store.dispatch('proveedor/inicializar', params)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this

      this.$store.dispatch('condicionesfiscales/getCondicionesFiscales')
        .then(() => {
          vm.condicionesFiscales = this.$store.getters['condicionesfiscales/list']
          vm.condicionesFiscalesList = this.$store.getters['condicionesfiscales/selectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de condiciones fiscales.'));

      this.$store.dispatch('documentostipos/getList')
        .then(() => {
          vm.documentosTipos = this.$store.getters['documentostipos/list']
          vm.documentosTiposList = this.$store.getters['documentostipos/selectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de tipos de identificación.'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'nombreComercial' || validarTodos) {
        if (this.$v.nombreComercial.$error) {
          this.nombreComercialValido = false;
          if (!this.$v.nombreComercial.required) {
            this.nombreComercialInvalidoMsj= 'Debe ingresar el nombre comercial.';
          } else if (!this.$v.nombreComercial.maxLength) {
            this.nombreComercialInvalidoMsj = 'El nombre comercial solo puede contener hasta 75 caracteres';
          } 
        } else {
          this.nombreComercialValido = null;
          this.nombreComercialInvalidoMsj = '';
        }
      }
        
      if (campo == 'razonSocial' || validarTodos) {
        if (this.$v.razonSocial.$error) {
          this.razonSocialValida = false;
          if (!this.$v.razonSocial.required) {
            this.razonSocialInvalidaMsj = 'Debe ingresar la razón social.';
          } else if (!this.$v.razonSocial.maxLength) {
            this.razonSocialInvalidaMsj = 'La razón social solo puede contener hasta 75 caracteres';
          }
        } else {
          this.razonSocialValida = null;
          this.razonSocialInvalidaMsj = '';
        }
      }

      if (campo == 'documentoNumero' || validarTodos) {
        if (this.$v.documentoNumero.$error) {
          this.documentoNumeroValido = false;
          if (!this.$v.documentoNumero.required) {
            this.documentoNumeroInvalidoMsj = 'Debe ingresar el código de identificación del proveedor';
          } else if (!this.$v.documentoNumero.DocumentoValido) {
            this.documentoNumeroInvalidoMsj = 'Verifique por favor el código de identificación ingresado';
          } else if (!this.$v.documentoNumero.maxLength) {
            this.documentoNumeroInvalidoMsj = 'El código de identificación solo puede contener hasta 20 caracteres';
          }      
        } else {
          this.documentoNumeroValido = null;
          this.documentoNumeroInvalidoMsj = '';
        }
      }

      // if (campo == 'cuit' || validarTodos) {
      //   if (this.$v.cuit.$error) {
      //     this.cuitValido = false;
      //     if (!this.$v.cuit.required) {
      //       this.cuitInvalidoMsj = 'Debe ingresar el CUIT.';
      //     } else if (!this.$v.cuit.numeric) {
      //       this.cuitInvalidoMsj = 'El CUIT solo puede contener números.';
      //     } else if (!this.$v.cuit.CUIT) {
      //       this.cuitInvalidoMsj = 'Verifique por favor el CUIT ingresado.';
      //     }      
      //   } else {
      //     this.cuitValido = null;
      //     this.cuitInvalidoMsj = '';
      //   }
      // }

      if (campo == 'telefono' || validarTodos) {
        if (this.$v.telefono.$error) {
          this.telefonoValido = false;
          if (!this.$v.telefono.maxLength) {
            this.telefonoInvalidoMsj = 'El número de teléfono solo puede contener hasta 50 caracteres.';
          }      
        } else {
          this.telefonoValido = null;
          this.telefonoInvalidoMsj = '';
        }
      }
          
      if (campo == 'celular' || validarTodos) {
        if (this.$v.celular.$error) {
          this.celularValido = false;
          if (!this.$v.celular.maxLength) {
            this.celularInvalidoMsj = 'El número de celular solo puede contener hasta 50 caracteres.';
          }      
        } else {
          this.celularValido = null;
          this.celularInvalidoMsj = '';
        }
      }

      if (campo == 'email' || validarTodos) {
        if (this.$v.email.$error) {
          this.emailValido = false
          if (!this.$v.email.email) {
            this.emailInvalidoMsj = 'El email ingresado no parece ser una dirección de correo válida.';
          } else if (!this.$v.email.maxLength) {
            this.emailInvalidoMsj = 'El email solo puede contener hasta 150 caracteres.';
          }      
        } else {
          this.emailValido = null;
          this.emailInvalidoMsj = '';
        }
      }
          
      if (campo == 'email2' || validarTodos) {
        if (this.$v.email2.$error) {
          this.email2Valido = false;
          if (!this.$v.email2.email) {
            this.email2InvalidoMsj = 'El email ingresado no parece ser una dirección de correo válida.';
          } else if (!this.$v.email2.maxLength) {
            this.email2InvalidoMsj = 'El email solo puede contener hasta 150 caracteres.';
          }      
        } else {
          this.email2Valido = null;
          this.email2InvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      if (!this.objetoValido('condicionFiscal', this.condicionFiscalNombre, this.condicionesFiscales, 
        'setCondicionFiscal', true, this.condicionFiscalValida, this.condicionFiscalInvalidaMsj, 
        'Debe seleccionar la condición fiscal.')) {
          save = false;
      }

      if (!this.objetoValido('documentoTipo', this.documentoTipoNombre, this.documentosTipos, 
        'setDocumentoTipo', true, this.documentoTipoValido, this.documentoTipoInvalidoMsj, 
        'Debe seleccionar el tipo de identificación.')) {
          save = false;
      }

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('proveedor/save')
            .then(()  => {
              this.$emit('updateProveedor', 
                this.$store.getters['proveedor/proveedor']);
            })
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        } 
      }
    },
    objetoValido(objeto, objetoNombre, objetoList, objetoDispatch, validar, 
        objetoValido, objetoInvalidoField, objetoInvalidoMsj) {
      let isValido = true;
      let selected = null;
      if (objetoNombre) {
        selected = this.getSelected(objetoList, objetoNombre);
      }
      this.$store.dispatch('proveedor/' + objetoDispatch, selected);

      let objetoStore = this.$store.getters['proveedor/' + objeto];

      if (validar) {
        if (objetoStore) {
          if (objetoStore.id) {
            if (objetoStore.id != 0) {
              isValido = false;
            }
          }
        }
        if (!isValido) {
          objetoValido = false;
          objetoInvalidoField = objetoInvalidoMsj;
        }
      }
      return isValido;
    },
    goBack() {
      this.$emit('closeProveedor');
    },
    condicionFiscalActualizada(condicionFiscalNombre) {
      if ( condicionFiscalNombre ) {
        this.condicionFiscalNombre = condicionFiscalNombre;
        this.condicionFiscalValida = null;
        this.condicionFiscalInvalidaMsj = '';
      }
    },
    documentoTipoActualizado(documentoTipoNombre) {
      this.documentoTipoNombre = documentoTipoNombre;
      if (this.documentoTipoNombre) {
        this.documentoTipoValido = null;
        this.documentoTipoInvalidoMsj = '';
      }
    },
  },
  watch: {
  },
  validations: {
    nombreComercial: {
      required,
      maxLength: maxLength(75)
    },
    razonSocial: {
      required,
      maxLength: maxLength(75)
    },
    documentoNumero: {
      required: requiredIf(function () {
        var isRequired = true;

        if (this.condicionFiscalNombre) {
          var condicionFiscal = this.getSelected(this.condicionesFiscales, this.condicionFiscalNombre);
          if (condicionFiscal) {
            if (condicionFiscal.id == 3) {
              isRequired = false;
            }
          }
        }
        return isRequired;
      }),
      DocumentoValido,
      maxLength: maxLength(20)
    },
    // cuit: {
    //   required: requiredIf(function () {
    //     var isRequired = true;

    //     if (this.condicionFiscalNombre) {
    //       var condicionFiscal = this.getSelected(this.condicionesFiscales, this.condicionFiscalNombre);
    //       if (condicionFiscal) {
    //         if (condicionFiscal.id == 3) {
    //           isRequired = false;
    //         }
    //       }
    //     }

    //     return isRequired;
    //   }),
    //   numeric,
    //   CUIT
    // },
    telefono: {
      maxLength: maxLength(50)
    },
    celular: {
      maxLength: maxLength(50)
    },
    email: {
      email,
      maxLength: maxLength(150)
    },
    email2: {
      email,
      maxLength: maxLength(150)
    },
  },  
}
</script>

<style>
</style>
